import type { AxiosError } from 'axios';
import { createMutation } from 'react-query-kit';

import { client } from '../common';

type Variables = { phone: string; otp: string };
type VerifyOtpResponse = {};

export const useCustomerVerifyOtp = createMutation<
  VerifyOtpResponse,
  Variables,
  AxiosError
>({
  mutationFn: async (variables) =>
    client({
      url: 'v2/customers/me/phone/verify',
      method: 'PUT',
      data: variables,
    })
      .then((response) => response.data)
      .catch((err: any) => {
        throw new Error(err.response.data.errors.join(', '));
      }),
});
